package org.gstechnovos.jexonplastech.models

import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import org.jetbrains.compose.web.css.CSSColorValue

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    // The Blue top swoosh
    Primary(hex = "#0076BD", rgb = rgb(r = 0, g = 118, b = 189)),

    // The "JEXON" main text (Dark Charcoal)
    Secondary(hex = "#1F1F1F", rgb = rgb(r = 31, g = 31, b = 31)),

    // The Red bottom swoosh (Added for logo completeness)
    Accent(hex = "#E02939", rgb = rgb(r = 224, g = 41, b = 57)),

    // The "PLASTECH" sub-text (Medium Gray)
    Gray(hex = "#9E9E9E", rgb = rgb(r = 158, g = 158, b = 158)),

    // Generated light UI backgrounds based on the Gray tone
    LightGray(hex = "#ECECEC", rgb = rgb(r = 236, g = 236, b = 236)),
    LighterGray(hex = "#F7F7F7", rgb = rgb(r = 247, g = 247, b = 247))
}